/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingPageRefetchQueryVariables = {
    projectId?: string | null | undefined;
    invoiceProjectIds?: Array<string> | null | undefined;
    startYear: number;
    startMonth: number;
    startDay: number;
    endYear: number;
    endMonth: number;
    endDay: number;
};
export type ProjectInvoicingPageRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ProjectInvoicingPage_viewer">;
    } | null;
};
export type ProjectInvoicingPageRefetchQuery = {
    readonly response: ProjectInvoicingPageRefetchQueryResponse;
    readonly variables: ProjectInvoicingPageRefetchQueryVariables;
};



/*
query ProjectInvoicingPageRefetchQuery(
  $projectId: ID
  $invoiceProjectIds: [ID!]
  $startYear: Int!
  $startMonth: Int!
  $startDay: Int!
  $endYear: Int!
  $endMonth: Int!
  $endDay: Int!
) {
  viewer {
    ...ProjectInvoicingPage_viewer_28d6XB
    id
  }
}

fragment ExportInvoiceButton_company on Company {
  newXeroEnabled
  quickbooksEnabled
  economicEnabled
  quickbooksRealmId
  sageIntacctConnectionEnabled
  clients {
    edges {
      node {
        id
        name
        xeroContactId
        economicCustomerId
        quickbooksCustomerId
        quickbooksRealmId
        sageIntacctCustomerId
      }
    }
  }
}

fragment ExportInvoiceButton_project on ProjectType {
  id
  invoices {
    edges {
      node {
        id
        xeroId
        xeroTenantId
        quickbooksId
        economicId
        sageIntacctId
        quickbooksRealmId
        status
      }
    }
  }
}

fragment InvoiceFilterButton_company on Company {
  newXeroEnabled
  quickbooksEnabled
  economicEnabled
  sageIntacctConnectionEnabled
}

fragment InvoiceFilterButton_project on ProjectType {
  id
}

fragment InvoiceFilterButton_viewer on Viewer {
  filters(first: 1000000, filterSection: INVOICING_INVOICES) {
    edges {
      node {
        id
        name
        section
        value
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ProjectInvoicingPage_viewer_28d6XB on Viewer {
  ...ProjectInvoicingTableSection_viewer
  invoicesV2(first: 100000, invoiceProjectIds: $invoiceProjectIds) {
    edges {
      node {
        id
        projects {
          id
        }
      }
    }
  }
  company {
    currency
    clients {
      edges {
        node {
          id
          name
          xeroContactId
          economicCustomerId
          quickbooksCustomerId
          sageIntacctCustomerId
        }
      }
    }
    ...ProjectInvoicingTableSection_company
    id
  }
  project(internalId: $projectId) {
    id
    client {
      id
    }
    budgetType
    ...ProjectInvoicingTotals_project
    ...ProjectInvoicingUninvoicedItemsTableSection_project_ytCB2
    ...ProjectInvoicingTableSection_project
  }
}

fragment ProjectInvoicingTableSection_company on Company {
  newXeroEnabled
  quickbooksEnabled
  economicEnabled
  sageIntacctConnectionEnabled
  ...ProjectInvoicingTable_company
  ...ExportInvoiceButton_company
  ...InvoiceFilterButton_company
}

fragment ProjectInvoicingTableSection_project on ProjectType {
  id
  companyProjectId
  ...ProjectInvoicingTable_project
  ...InvoiceFilterButton_project
  invoices {
    edges {
      node {
        id
        companyInvoiceId
      }
    }
  }
}

fragment ProjectInvoicingTableSection_viewer on Viewer {
  ...InvoiceFilterButton_viewer
}

fragment ProjectInvoicingTable_company on Company {
  currency
  newXeroEnabled
  quickbooksEnabled
  economicEnabled
  sageIntacctConnectionEnabled
  integrations {
    userCanUnlinkInvoice
    id
  }
  ...ExportInvoiceButton_company
}

fragment ProjectInvoicingTable_project on ProjectType {
  id
  name
  rateCard {
    currency
    id
  }
  budget
  budgetType
  ...ExportInvoiceButton_project
  invoices {
    edges {
      node {
        invoicedWithoutTax
        invoicedWithoutTaxProjectCurrency
        paidWithoutTax
        paidWithoutTaxProjectCurrency
        quickbooksId
        sageIntacctId
        economicId
        xeroId
        id
        invoiceReference
        companyInvoiceId
        currency
        status
        externalStatus
        quickbooksRealmId
        paymentStatus
        createdYear
        createdMonth
        createdDay
        dueYear
        dueMonth
        dueDay
        name
        client {
          id
          name
        }
      }
    }
  }
}

fragment ProjectInvoicingTotals_project on ProjectType {
  id
  name
  rateCard {
    currency
    id
  }
  budget
  budgetType
  defaultPeriodBudgetType
  invoices {
    edges {
      node {
        status
        invoicedWithoutTaxProjectCurrency
        paidWithoutTaxProjectCurrency
        unpaidWithoutTaxProjectCurrency
        dueDay
        dueMonth
        dueYear
        id
      }
    }
  }
  timeFinancialNumbers: financialNumbers(searchQuery: {filters: [{field: ROLE, operator: NOT_IN, value: "Um9sZTotMQ=="}]}, convertToProjectCurrency: true) {
    billableActualTimeAndExpenses
  }
  financialNumbers(convertToProjectCurrency: true) {
    totalRevenueRecognition
    totalActualRevenueRecognition
    expenseRevenuePercentage
  }
  expenseItems(first: 10000) {
    edges {
      node {
        approved
        billable
        partOfFixedPrice
        expenseYear
        expenseMonth
        expenseDay
        price
        cost
        quantity
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ProjectInvoicingUninvoicedItemsTableSection_project_ytCB2 on ProjectType {
  id
  unInvoicedTotal(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {
    unInvoicedMinutes
    unInvoicedPrice
  }
  name
  rateCard {
    currency
    id
  }
  budget
  budgetType
  defaultPeriodBudgetType
  expenseItems(first: 10000) {
    edges {
      node {
        approved
        billable
        partOfFixedPrice
        expenseYear
        expenseMonth
        expenseDay
        price
        cost
        quantity
        invoiced
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invoiceProjectIds",
    "type": "[ID!]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int!"
  }
],
v1 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v2 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v3 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v4 = {
  "kind": "Variable",
  "name": "invoiceProjectIds",
  "variableName": "invoiceProjectIds"
},
v5 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v6 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v7 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v8 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "INVOICING_INVOICES"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v9/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksRealmId",
  "storageKey": null
},
v17 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectInvoicingPageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectInvoicingPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectInvoicingPageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": "filters(filterSection:\"INVOICING_INVOICES\",first:1000000)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000
              },
              (v4/*: any*/)
            ],
            "concreteType": "InvoiceTypeConnection",
            "kind": "LinkedField",
            "name": "invoicesV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": true,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "clients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "xeroContactId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "economicCustomerId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quickbooksCustomerId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sageIntacctCustomerId",
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newXeroEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quickbooksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "economicEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctConnectionEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userCanUnlinkInvoice",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoicedWithoutTaxProjectCurrency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paidWithoutTaxProjectCurrency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unpaidWithoutTaxProjectCurrency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueYear",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "xeroId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "xeroTenantId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quickbooksId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "economicId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sageIntacctId",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoicedWithoutTax",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paidWithoutTax",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiceReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyInvoiceId",
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paymentStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDay",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Client",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "timeFinancialNumbers",
                "args": [
                  (v17/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "searchQuery",
                    "value": {
                      "filters": [
                        {
                          "field": "ROLE",
                          "operator": "NOT_IN",
                          "value": "Um9sZTotMQ=="
                        }
                      ]
                    }
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true,searchQuery:{\"filters\":[{\"field\":\"ROLE\",\"operator\":\"NOT_IN\",\"value\":\"Um9sZTotMQ==\"}]})"
              },
              {
                "alias": null,
                "args": [
                  (v17/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseRevenuePercentage",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "ExpenseItemTypeConnection",
                "kind": "LinkedField",
                "name": "expenseItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseItemTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partOfFixedPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "price",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cost",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiced",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": "expenseItems(first:10000)"
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_expenseItems",
                "kind": "LinkedHandle",
                "name": "expenseItems"
              },
              {
                "alias": null,
                "args": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "concreteType": "UnInvoicedProjectTotal",
                "kind": "LinkedField",
                "name": "unInvoicedTotal",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unInvoicedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unInvoicedPrice",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ProjectInvoicingPageRefetchQuery",
    "operationKind": "query",
    "text": "query ProjectInvoicingPageRefetchQuery(\n  $projectId: ID\n  $invoiceProjectIds: [ID!]\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n) {\n  viewer {\n    ...ProjectInvoicingPage_viewer_28d6XB\n    id\n  }\n}\n\nfragment ExportInvoiceButton_company on Company {\n  newXeroEnabled\n  quickbooksEnabled\n  economicEnabled\n  quickbooksRealmId\n  sageIntacctConnectionEnabled\n  clients {\n    edges {\n      node {\n        id\n        name\n        xeroContactId\n        economicCustomerId\n        quickbooksCustomerId\n        quickbooksRealmId\n        sageIntacctCustomerId\n      }\n    }\n  }\n}\n\nfragment ExportInvoiceButton_project on ProjectType {\n  id\n  invoices {\n    edges {\n      node {\n        id\n        xeroId\n        xeroTenantId\n        quickbooksId\n        economicId\n        sageIntacctId\n        quickbooksRealmId\n        status\n      }\n    }\n  }\n}\n\nfragment InvoiceFilterButton_company on Company {\n  newXeroEnabled\n  quickbooksEnabled\n  economicEnabled\n  sageIntacctConnectionEnabled\n}\n\nfragment InvoiceFilterButton_project on ProjectType {\n  id\n}\n\nfragment InvoiceFilterButton_viewer on Viewer {\n  filters(first: 1000000, filterSection: INVOICING_INVOICES) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectInvoicingPage_viewer_28d6XB on Viewer {\n  ...ProjectInvoicingTableSection_viewer\n  invoicesV2(first: 100000, invoiceProjectIds: $invoiceProjectIds) {\n    edges {\n      node {\n        id\n        projects {\n          id\n        }\n      }\n    }\n  }\n  company {\n    currency\n    clients {\n      edges {\n        node {\n          id\n          name\n          xeroContactId\n          economicCustomerId\n          quickbooksCustomerId\n          sageIntacctCustomerId\n        }\n      }\n    }\n    ...ProjectInvoicingTableSection_company\n    id\n  }\n  project(internalId: $projectId) {\n    id\n    client {\n      id\n    }\n    budgetType\n    ...ProjectInvoicingTotals_project\n    ...ProjectInvoicingUninvoicedItemsTableSection_project_ytCB2\n    ...ProjectInvoicingTableSection_project\n  }\n}\n\nfragment ProjectInvoicingTableSection_company on Company {\n  newXeroEnabled\n  quickbooksEnabled\n  economicEnabled\n  sageIntacctConnectionEnabled\n  ...ProjectInvoicingTable_company\n  ...ExportInvoiceButton_company\n  ...InvoiceFilterButton_company\n}\n\nfragment ProjectInvoicingTableSection_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectInvoicingTable_project\n  ...InvoiceFilterButton_project\n  invoices {\n    edges {\n      node {\n        id\n        companyInvoiceId\n      }\n    }\n  }\n}\n\nfragment ProjectInvoicingTableSection_viewer on Viewer {\n  ...InvoiceFilterButton_viewer\n}\n\nfragment ProjectInvoicingTable_company on Company {\n  currency\n  newXeroEnabled\n  quickbooksEnabled\n  economicEnabled\n  sageIntacctConnectionEnabled\n  integrations {\n    userCanUnlinkInvoice\n    id\n  }\n  ...ExportInvoiceButton_company\n}\n\nfragment ProjectInvoicingTable_project on ProjectType {\n  id\n  name\n  rateCard {\n    currency\n    id\n  }\n  budget\n  budgetType\n  ...ExportInvoiceButton_project\n  invoices {\n    edges {\n      node {\n        invoicedWithoutTax\n        invoicedWithoutTaxProjectCurrency\n        paidWithoutTax\n        paidWithoutTaxProjectCurrency\n        quickbooksId\n        sageIntacctId\n        economicId\n        xeroId\n        id\n        invoiceReference\n        companyInvoiceId\n        currency\n        status\n        externalStatus\n        quickbooksRealmId\n        paymentStatus\n        createdYear\n        createdMonth\n        createdDay\n        dueYear\n        dueMonth\n        dueDay\n        name\n        client {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectInvoicingTotals_project on ProjectType {\n  id\n  name\n  rateCard {\n    currency\n    id\n  }\n  budget\n  budgetType\n  defaultPeriodBudgetType\n  invoices {\n    edges {\n      node {\n        status\n        invoicedWithoutTaxProjectCurrency\n        paidWithoutTaxProjectCurrency\n        unpaidWithoutTaxProjectCurrency\n        dueDay\n        dueMonth\n        dueYear\n        id\n      }\n    }\n  }\n  timeFinancialNumbers: financialNumbers(searchQuery: {filters: [{field: ROLE, operator: NOT_IN, value: \"Um9sZTotMQ==\"}]}, convertToProjectCurrency: true) {\n    billableActualTimeAndExpenses\n  }\n  financialNumbers(convertToProjectCurrency: true) {\n    totalRevenueRecognition\n    totalActualRevenueRecognition\n    expenseRevenuePercentage\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        approved\n        billable\n        partOfFixedPrice\n        expenseYear\n        expenseMonth\n        expenseDay\n        price\n        cost\n        quantity\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectInvoicingUninvoicedItemsTableSection_project_ytCB2 on ProjectType {\n  id\n  unInvoicedTotal(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {\n    unInvoicedMinutes\n    unInvoicedPrice\n  }\n  name\n  rateCard {\n    currency\n    id\n  }\n  budget\n  budgetType\n  defaultPeriodBudgetType\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        approved\n        billable\n        partOfFixedPrice\n        expenseYear\n        expenseMonth\n        expenseDay\n        price\n        cost\n        quantity\n        invoiced\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '383d77ad7b8f0b5155eba108bf231573';
export default node;
